<script>
import Icons from 'images/icons.svg';

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: null
    }
  },

  computed: {
    href() {
      return `${Icons}#${this.name}`;
    },

    sizeClass() {
      return `c-icon--${this.size}`;
    },

    classes() {
      return ['c-icon', this.size ? this.sizeClass : ''];
    }
  }
};
</script>

<template>
  <svg
    :class="classes"
    stroke="currentColor"
  >
    <use :xlink:href="href" />
  </svg>
</template>
